import { RefObject } from 'react';

import { Marker } from '../../../types/iMediaPlayer';
import MediaMethods from '../../atoms/mediaDataCollector/MediaMethods';

interface ProgressBarProps {
  playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>;
  progressBarRef: RefObject<HTMLInputElement>;
  updateProgressBarAndPlayerCurrentTime: () => Promise<void>;
  markers: Marker[] | undefined;
  sectionId: string;
  duration: string;
  className?: string;
}

function ProgressBar({
  playerRef,
  progressBarRef,
  updateProgressBarAndPlayerCurrentTime,
  className = '',
  markers,
  sectionId,
  duration,
}: ProgressBarProps) {
  return (
    /*    <MediaDataCollector
          playerRef={playerRef}
          markers={markers}
          sectionId={sectionId}
          duration={duration}
          convertSecondsToTime={convertSecondsToTime}
        >
        </MediaDataCollector>*/
    <input
      ref={progressBarRef}
      className={`progress-bar ${className}`}
      type="range"
      defaultValue={0}
      onChange={() =>
        MediaMethods.updateCurrentTimeFromProgressBar(playerRef, progressBarRef, updateProgressBarAndPlayerCurrentTime)
      }
    />
  );
}

export default ProgressBar;
